import * as types from '../constants/userAttributesActionTypes';

const initialState = {
  data: null,
  is_loading: false,
  error: null,
};

function userAttributes(state = initialState, action) {
  switch (action.type) {
    case types.USER_ATTRIBUTES_LOAD_REQUEST:
      return {...state, is_loading: true, error: null};
    case types.USER_ATTRIBUTES_LOAD_SUCCESS:
      return {data: action.attributes, is_loading: false, error: null};
    case types.USER_ATTRIBUTES_LOAD_FAILURE:
      return {...state, is_loading: false, error: action.error};
    default:
      return state;
  }
}

export default userAttributes;
